import { ProdutosService } from './../../service/produtos.service';
import { ThemePalette } from '@angular/material/core';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { AlertService } from './../../service/alert.service';
import { ClientesService } from 'src/app/service/clientes.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-criar-cliente',
  templateUrl: './criar-cliente.component.html',
  styleUrls: ['./criar-cliente.component.css']
})
export class CriarClienteComponent implements OnInit {

  map?: google.maps.Map;
  latlgn: any;
  form!: FormGroup;
  markers = [] as any;
  load = false;
  value = 50;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  produtos = [] as any

  constructor(private router: Router,
    private service: ClientesService,
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private produtoService: ProdutosService
  ) {
    this.form = this.formBuilder.group({
      vc_nome: new FormControl('', [Validators.required]),
      vc_cidade: new FormControl('', [Validators.required]),
      vc_cnpj: new FormControl('', [Validators.required]),
      vc_codigo_postal: new FormControl('', [Validators.required]),
      vc_complemento: new FormControl('', [Validators.required]),
      vc_pais: new FormControl('', [Validators.required]),
      vc_endereco: new FormControl('', [Validators.required]),
      vc_email_responsavel: new FormControl('', [Validators.required, Validators.email]),
      vc_nome_responsavel: new FormControl('', [Validators.required]),
      vc_estado: new FormControl('', [Validators.required]),
      ar_produtos: new FormControl([], [Validators.required])
    })
  }

  ngOnInit(): void {
    this.listarProdutos()
    this.map = new google.maps.Map(document.getElementById("map") as HTMLDivElement, {
      center: { lat: -20.8202, lng: -49.3797 },
      zoom: 8,
      mapTypeId: 'satellite',
    });
    this.map.addListener("click", (mapsMouseEvent: any) => {
      if (this.markers.length != 0) {
        this.hideMarkers();
        this.markers = [];
      }
      this.latlgn = mapsMouseEvent.latLng
      const marker = new google.maps.Marker({
        position: mapsMouseEvent.latLng,
        map: this.map,
      });
      this.markers.push(marker);
    });
  }

  hideMarkers() {
    this.setMapOnAll(null)
  }

  setMapOnAll(map: google.maps.Map | null) {
    for (let i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(map);
    }
  }

  removeEspacosBrancosDoFormulario(): void {
    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);

      if (control instanceof FormControl && typeof control.value === 'string') {
        control.setValue(control.value.trim());
        control.markAsDirty();
      }
    });
  }

  cadastrar(): void {
    this.removeEspacosBrancosDoFormulario();
    if (!this.form.valid) {
      this.alertService.error("Preencha todos os campos");
      return;
    }
    if (this.latlgn == undefined) {
      this.alertService.error("Marque a localização da empresa no mapa");
      return;
    }
    this.load = true
    var json = this.form.value
    json.vc_latitude = this.latlgn.lat()
    json.vc_longitude = this.latlgn.lng()
    this.service.cadastrarService(json).subscribe(resp => {
      this.load = false
      this.alertService.success();
      this.router.navigate(['configuracao/clientes']);
    }, error => {
      this.load = false
      if (typeof error == 'object') {
        if (typeof error.error.mensagem == 'string') {
          this.alertService.error(error.error.mensagem);
        } else {
          this.alertService.error(error.error.mensagem[0]);
        }
      } else {
        this.alertService.error(error)
      }
    })
  }



  cancel() {
    this.router.navigate(['configuracao/clientes']);
  }

  listarProdutos() {
    this.produtoService.listarService().subscribe((resp: any) => {
      this.produtos = resp.filter(function (elem: any) {
        return elem.sr_id != 1
      })
    }, error => {

    })
  }

}
